export default "__VITE_ASSET__SNJfzep4__"